import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import {
  onFetchOnboardingOrders,
  saveOrderId,
  fetchOnboardingOrderDetails,
  clearOrderDetails,
  onChangeChecklistStatus,
  onAddChecklistNote,
  onUpdateChecklistNote,
  onAddChecklistDocument,
  stopOnboardingLoader,
  clearOrders,
  saveNotaryForm,
  clearConveyanceForm,
  clearSaveConveyanceFormData,
} from 'src/store/actions/HomeOwnerOnboardingDashboard';
import { ConstructionStages } from '../../ConstructionStages';
import {
  clearConstructionStages,
  fetchPropertyStages,
} from 'src/store/actions/HomeownerOnboardingComponent';
import VideoPlayer from '../../../Document/VideoPlayer';
import Loader from '../../../Loader';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import AddNote from './AddNote';
import AddDocument from './AddDocument';
import Checklist from './Checklist';
import Col from '../../../Col';
import Row from '../../../Row';
import { upload } from 'src/helpers/upLoadHelper';
import Button from '../../../Button';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import DocumentTitle from 'react-document-title';
import TextEditor from '../../../Editor/Editor';
import OrdersList from './OrdersList';
import KeycontactsList from './KeycontactsList';
import FaqsList from './FaqsList';
import { fetchtAllowedTabList } from 'src/store/actions/tabSelections';
import {
  clearActiveTab,
  clearActiveSuiteTab,
  clearActiveCatalogTab,
  clearActiveContactTab,
} from 'src/store/actions/activeTab';
import FeedBack from '../../../FeedBack';
import { USER_ROLES } from 'src/common/constants';
import { checkMediaType } from 'src/helpers/CommonHelpers';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './HomeOwnerOnboardingDashboard.scss';
import './Media.scss';
import { useBranding } from 'src/branding/BrandingContextProvider';

const HomeOwnerOnboardingDashboard = ({ currentUserSuite }) => {
  const dispatch = useDispatch();

  const user: any = useSelector(selectAuthenticatedUser);
  const onboardingData: any = useSelector((state: any) => state.onboardingData);
  const constructionStages: any = useSelector(
    (state: any) => state.constructionStages
  );
  const loader: any = useSelector(selectFormLoader);

  const [state, setState] = useState({
    isOpenPopup: false,
    isOpenDocumentPopup: false,
    note: '',
    originalNote: '',
    convertedNote: '',
    checklistId: '',
    documents: [],
    selectedFaqsId: [],
    lawFirm: null,
    lawyer: null,
    maillingAddress: null,
    email: null,
    phone: null,
    fax: null,
    financialInstitution: null,
    orderId: null,
    imageLoading: false,
    feedBackReportPopup: false,
    noteId: '',
  });

  const mergeState = (partial: any) =>
    setState((prev: any) => ({ ...prev, ...partial }));

  const willMountRan = useRef(false);

  if (!willMountRan.current) {
    willMountRan.current = true;
    dispatch(clearActiveTab());
    dispatch(clearActiveSuiteTab());
    dispatch(clearActiveCatalogTab());
    dispatch(clearActiveContactTab());
  }

  useEffect(() => {
    dispatch(stopOnboardingLoader());
    dispatch(clearConstructionStages());
    dispatch(clearOrderDetails());
    dispatch(clearConveyanceForm());
    dispatch(fetchPropertyStages(currentUserSuite.propertyId));
    dispatch(fetchtAllowedTabList(currentUserSuite.propertyId));

    if (
      user &&
      user.roles &&
      user.roles.length > 0 &&
      user.roles[0].role.name?.toUpperCase() ===
        USER_ROLES.HOME_OWNER.toUpperCase()
    ) {
      let isfeedBackReportPopup = localStorage.getItem(
        'IsHomerNavigatFromFeedBackTemplate'
      );
      if (
        isfeedBackReportPopup !== undefined &&
        isfeedBackReportPopup !== null &&
        isfeedBackReportPopup != ''
      ) {
        mergeState({ feedBackReportPopup: true });
      }
    }
  }, []);

  // componentDidUpdate — watching currentUserSuite.id
  const prevCurrentUserSuiteIdRef = useRef(currentUserSuite.id);
  useEffect(() => {
    if (prevCurrentUserSuiteIdRef.current !== currentUserSuite.id) {
      prevCurrentUserSuiteIdRef.current = currentUserSuite.id;

      dispatch(clearOrders());
      dispatch(clearConstructionStages());
      dispatch(clearOrderDetails());
      dispatch(clearConveyanceForm());
      dispatch(
        onFetchOnboardingOrders(
          currentUserSuite.propertyId,
          currentUserSuite.id,
          user.id
        )
      );
      dispatch(fetchPropertyStages(currentUserSuite.propertyId));
    }
  }, [currentUserSuite.id]);

  const onFetchOrderDetails = (orderId) => {
    mergeState({
      lawFirm: null,
      lawyer: null,
      maillingAddress: null,
      email: null,
      phone: null,
      fax: null,
      financialInstitution: null,
      orderId: orderId,
    });

    dispatch(clearSaveConveyanceFormData());
    dispatch(saveOrderId(orderId));
    dispatch(
      fetchOnboardingOrderDetails(
        currentUserSuite.propertyId,
        orderId,
        currentUserSuite.id,
        user.id
      )
    );

    mergeState({ selectedFaqsId: [] });
    dispatch(clearConveyanceForm());
  };

  const onChangeChecklistStatusHandler = (data) => {
    let params: any = {
      userId: user.id,
      suiteOnBoardingChecklist: [
        {
          id: data.id,
          ischecked: !data.ischecked,
        },
      ],
    };
    dispatch(onChangeChecklistStatus(params));
  };

  const onDeleteCreatedDoc = (doc) => {
    let params: any = {
      userId: user.id,
      urls: [
        {
          id: doc.id,
          url: doc.url,
          isdeleted: true,
        },
      ],
      checklistId: doc.checklistId,
      suiteId: currentUserSuite.id,
    };

    dispatch(onAddChecklistDocument(params, 'delete'));
  };

  const onUpdateDeleteChecklistNote = (note, type) => {
    if (type === 'update') {
      let summaryText;
      let editorState = note.description ? note.description : '';
      summaryText = note.description.replace(/<[^>]+>/g, '');

      mergeState({
        noteId: note.id,
        checklistId: note.checklistId,
        note: editorState,
        originalNote: note.description,
        convertedNote: summaryText,
        isOpenPopup: true,
      });
    } else {
      dispatch(onAddChecklistDocument());
    }
  };

  const onAddNote = (type) => {
    if (type === 'close') {
      mergeState({
        isOpenPopup: false,
        checklistId: '',
        note: '',
        originalNote: '',
        convertedNote: '',
        noteId: '',
      });
    } else {
      let params: any = {
        userId: user.id,
        description: state.originalNote,
        checklistId: state.checklistId,
      };
      if (state.noteId) {
        params.id = state.noteId;
        dispatch(onUpdateChecklistNote(params));
      } else {
        dispatch(onAddChecklistNote(params));
      }

      mergeState({
        isOpenPopup: false,
        checklistId: '',
        note: '',
        originalNote: '',
        convertedNote: '',
        noteId: '',
      });
    }
  };

  const onSetNote = (editorState) => {
    let convertToText = editorState;
    let summaryText = convertToText.replace(/<[^>]+>/g, '');

    mergeState({
      note: editorState,
      originalNote: editorState,
      convertedNote: summaryText,
    });
  };

  const uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile);

    let object = {
      Url: imageUrl,
    };

    callback(object);
  };

  const handleMultipleUpload = async (selectedImage, callback) => {
    let uploadImages = [];

    for (let i = 0; i < selectedImage.length; i++) {
      await uploadimg(selectedImage[i], (imgData) => {
        uploadImages.push(imgData);
      });
    }

    callback(uploadImages);
  };

  const onAddDocument = async (type) => {
    if (type === 'close') {
      mergeState({
        isOpenDocumentPopup: false,
        checklistId: '',
        documents: [],
      });
    } else {
      mergeState({ imageLoading: true });
      let params = {};
      let attachments = [];

      await handleMultipleUpload(state.documents, function (resObj) {
        attachments = resObj;
      });

      mergeState({ imageLoading: false });

      params = {
        userId: user.id,
        urls: attachments,
        checklistId: state.checklistId,
        suiteId: currentUserSuite.id,
      };

      dispatch(onAddChecklistDocument(params));
      clearData();
    }
  };

  const clearData = () => {
    mergeState({
      isOpenDocumentPopup: false,
      documents: [],
      checklistId: '',
    });
  };

  const onSelectDocuments = (file: any) => {
    mergeState({ documents: [...state.documents, ...file] });
  };

  const onDeleteDoc = (file: any) => {
    let data = state.documents.filter((doc: any) => doc !== file);
    mergeState({ documents: data });
  };

  const handleSelectFaqs = (faqId: any) => {
    let selectedFaqsId = state.selectedFaqsId;
    let faqObj = selectedFaqsId.filter((fId: any) => fId === faqId)[0];
    if (faqObj) {
      selectedFaqsId = selectedFaqsId.filter((fId: any) => fId !== faqObj);
    } else {
      selectedFaqsId = [...selectedFaqsId, faqId];
    }

    mergeState({ selectedFaqsId });
  };

  const callSaveNotaryForm = (orderID) => {
    let details = onboardingData.orderDetails;
    const validEmailRegex =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    if (
      state.lawFirm === null &&
      state.lawyer === null &&
      state.maillingAddress === null &&
      state.email === null &&
      state.phone === null &&
      state.fax === null &&
      state.financialInstitution === null
    ) {
      alert('Please provide information before submitting form.');
    } else if (
      state.lawFirm === '' &&
      state.lawyer === '' &&
      state.maillingAddress === '' &&
      state.email === '' &&
      state.phone === '' &&
      state.fax === null &&
      state.financialInstitution === ''
    ) {
      alert('Please provide information before submitting form.');
    } else {
      if (state.email) {
        if (!validEmailRegex.test(state.email.toLowerCase())) {
          alert('Please enter a valid email address.');
        } else {
          let params: any = {
            LawFirmNotary:
              state.lawFirm != null
                ? state.lawFirm
                : onboardingData.fetchConveyanceFormData.lawFirmNotary,
            LawyerNotaryContactName:
              state.lawyer != null
                ? state.lawyer
                : onboardingData.fetchConveyanceFormData
                    .lawyerNotaryContactName,
            MailingAddress:
              state.maillingAddress != null
                ? state.maillingAddress
                : onboardingData.fetchConveyanceFormData.mailingAddress,
            Email:
              state.email != null
                ? state.email
                : onboardingData.fetchConveyanceFormData.email,
            Phone:
              state.phone != null
                ? state.phone
                : onboardingData.fetchConveyanceFormData.phone,
            Fax:
              state.fax != null
                ? state.fax
                : onboardingData.fetchConveyanceFormData.fax,
            FinancialInstitutionBank:
              state.financialInstitution != null
                ? state.financialInstitution
                : onboardingData.fetchConveyanceFormData
                    .financialInstitutionBank,
            SuiteOnboardingId: details.id,
            SuiteId: currentUserSuite.id,
            UserId: user.id,
          };
          if (
            onboardingData.fetchConveyanceFormData.id !== '' &&
            onboardingData.fetchConveyanceFormData.id !== null
          ) {
            params.id = onboardingData.fetchConveyanceFormData.id;
          }
          dispatch(saveNotaryForm(params));
        }
      } else {
        let params: any = {
          LawFirmNotary:
            state.lawFirm != null
              ? state.lawFirm
              : onboardingData.fetchConveyanceFormData.lawFirmNotary,
          LawyerNotaryContactName:
            state.lawyer != null
              ? state.lawyer
              : onboardingData.fetchConveyanceFormData.lawyerNotaryContactName,
          MailingAddress:
            state.maillingAddress != null
              ? state.maillingAddress
              : onboardingData.fetchConveyanceFormData.mailingAddress,
          Email:
            state.email != null
              ? state.email
              : onboardingData.fetchConveyanceFormData.email,
          Phone:
            state.phone != null
              ? state.phone
              : onboardingData.fetchConveyanceFormData.phone,
          Fax:
            state.fax != null
              ? state.fax
              : onboardingData.fetchConveyanceFormData.fax,
          FinancialInstitutionBank:
            state.financialInstitution != null
              ? state.financialInstitution
              : onboardingData.fetchConveyanceFormData.financialInstitutionBank,
          SuiteOnboardingId: details.id,
          SuiteId: currentUserSuite.id,
          UserId: user.id,
        };
        if (
          onboardingData.fetchConveyanceFormData.id !== '' &&
          onboardingData.fetchConveyanceFormData.id !== null
        ) {
          params.id = onboardingData.fetchConveyanceFormData.id;
        }
        dispatch(saveNotaryForm(params));
      }
    }
  };

  let details: any = onboardingData.orderDetails;
  let orderID: any = onboardingData.orderId;
  let lawFirm: any = onboardingData.fetchConveyanceFormData.lawFirmNotary;
  let lawyer: any =
    onboardingData.fetchConveyanceFormData.lawyerNotaryContactName;
  let maillingAddress: any =
    onboardingData.fetchConveyanceFormData.mailingAddress;
  let emails: any = onboardingData.fetchConveyanceFormData.email;
  let phones: any = onboardingData.fetchConveyanceFormData.phone;
  let faxs: any = onboardingData.fetchConveyanceFormData.fax;
  let financialInstitution: any =
    onboardingData.fetchConveyanceFormData.financialInstitutionBank;
  const conveyanceFormId: any = onboardingData.fetchConveyanceFormData.id;
  const { selectedFaqsId } = state;
  let videoSummary: any = details.videoSummary
    ? details.videoSummary.replace(/<[^>]+>/g, '')
    : '';
  let vSummary: any = details.videoSummary ? details.videoSummary : '';

  const theme: string = localStorage.getItem('theme');

  const {branding} = useBranding();

  return (
    <DocumentTitle
      title={ `Homeowner Onboarding Dashboard | ${branding.text.applicationName || 'juniper'}`}
    >
      <div className="header_section">
        {state.feedBackReportPopup &&
          details.suiteOnBoardingFAQs &&
          details.suiteOnBoardingFAQs.length === 0 && <FeedBack />}
        <div className="header_box">
          <div className="configure_heading">
            {onboardingData.orderDetails &&
            onboardingData.orderDetails.suiteOnBoardingTitle ? (
              <h2
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  fontSize: 25,
                  fontWeight: 'bold',
                }}
              >
                {onboardingData.orderDetails.suiteOnBoardingTitle}
              </h2>
            ) : (
              <h2
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  fontSize: 25,
                  fontWeight: 'bold',
                }}
              >
                Homeowner Information
              </h2>
            )}
          </div>
        </div>
        {(onboardingData && onboardingData.fetchDetailsLoading) ||
        state.imageLoading ? (
          <Loader center={true} />
        ) : null}
        <OrdersList
          onboardingData={onboardingData}
          onFetchOrderDetails={onFetchOrderDetails}
        />
        {details && details.id ? (
          <>
            <div className="mainRow mt-20">
              <div
                className="videoDiv"
                style={{
                  width:
                    (details.suiteOnboardingKeyInformation.length === 0 &&
                      '100%') ||
                    (!details.video &&
                      !(videoSummary && videoSummary.trim()) &&
                      '0%'),
                }}
              >
                {details.video ? (
                  <>
                    <div className="playVideo" style={{ textAlign: 'center' }}>
                      {checkMediaType(details.video, [
                        '.mov',
                        '.mp4',
                        'iframe',
                      ]) ? (
                        <VideoPlayer url={details.video} />
                      ) : (
                        <img className="limitHeight" src={details.video} />
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {videoSummary && videoSummary.trim() ? (
                  <div className="videoDetails">
                    <div className="videoSummaryScroll" style={{ padding: 10 }}>
                      <TextEditor
                        editorState={vSummary}
                        onEditorStateChange={null}
                        readOnly={true}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
              {details &&
                details.suiteOnboardingKeyInformation &&
                details.suiteOnboardingKeyInformation.length > 0 && (
                  <KeycontactsList
                    details={details}
                    videoSummary={videoSummary}
                  />
                )}
            </div>
            {constructionStages && constructionStages.length > 0 ? (
              <ConstructionStages constructionStages={constructionStages} />
            ) : null}
            {details.suiteOnBoardingChecklist &&
            details.suiteOnBoardingChecklist.length > 0 ? (
              <div className="mainRow mt-40">
                <div className="checklist">
                  <h2>Checklist</h2>
                  <Checklist
                    user={user}
                    checklist={details.suiteOnBoardingChecklist}
                    onChangeChecklistStatus={onChangeChecklistStatusHandler}
                    onDeleteCreatedDoc={onDeleteCreatedDoc}
                    isAddNote={(cl) =>
                      mergeState({ isOpenPopup: true, checklistId: cl.id })
                    }
                    isAddDocument={(cl) =>
                      mergeState({
                        isOpenDocumentPopup: true,
                        checklistId: cl.id,
                      })
                    }
                    onUpdateDeleteChecklistNote={onUpdateDeleteChecklistNote}
                  />
                </div>
              </div>
            ) : null}
            {/* Conveyance form. */}
            {details.isLegalRepresentativeInformation ? (
              <div className="mainRow mt-20">
                <div className="checklist">
                  <h2>Legal Representative Form</h2>
                  <div className="legalRepresentatives">
                    <Row>
                      <Col xs="12" md="4">
                        <label>Law Firm / Notary :</label>
                        <input
                          className="form-control"
                          type="text"
                          name=""
                          placeholder="Law Firm/ Notary"
                          value={
                            state.lawFirm != null ? state.lawFirm : lawFirm
                          }
                          onChange={(e: any) => {
                            mergeState({ lawFirm: e.target.value });
                          }}
                          required
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <label>Legal Representative Contact Name :</label>
                        <input
                          className="form-control"
                          type="text"
                          name=""
                          placeholder="Lawyer / Notary Contact Name"
                          value={state.lawyer != null ? state.lawyer : lawyer}
                          onChange={(e: any) =>
                            mergeState({ lawyer: e.target.value })
                          }
                          required
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <label>Legal Representative Mailing Address :</label>
                        <input
                          className="form-control"
                          type="text"
                          name=""
                          placeholder="Mailing Address"
                          value={
                            state.maillingAddress != null
                              ? state.maillingAddress
                              : maillingAddress
                          }
                          onChange={(e: any) =>
                            mergeState({ maillingAddress: e.target.value })
                          }
                          required
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <label>Legal Representative Email :</label>
                        <input
                          className="form-control"
                          type="email"
                          name=""
                          placeholder="Email"
                          value={state.email != null ? state.email : emails}
                          onChange={(e: any) =>
                            mergeState({ email: e.target.value })
                          }
                          required
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <label>Legal Representative Phone :</label>
                        <input
                          className="form-control"
                          type="text"
                          name=""
                          placeholder="Phone"
                          value={state.phone != null ? state.phone : phones}
                          onChange={(e: any) =>
                            mergeState({ phone: e.target.value })
                          }
                          required
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <label>Legal Representative Fax :</label>
                        <input
                          className="form-control"
                          type="text"
                          name=""
                          placeholder="Fax"
                          value={state.fax != null ? state.fax : faxs}
                          onChange={(e: any) =>
                            mergeState({ fax: e.target.value })
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" md="12">
                        <h4>Mortgage Financing Information (if applicable) </h4>
                        <label>Financial Institution / Bank :</label>
                        <input
                          className="form-control financialInstitution"
                          type="text"
                          name=""
                          placeholder="Financial Institution / Bank "
                          value={
                            state.financialInstitution != null
                              ? state.financialInstitution
                              : financialInstitution
                          }
                          onChange={(e: any) => {
                            mergeState({
                              financialInstitution: e.target.value,
                            });
                            financialInstitution = state.financialInstitution;
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" md="12">
                        <div className="text-right">
                          {user.roles[0].role.name !== 'Realtor' ? (
                            <Button
                              onClick={() => callSaveNotaryForm(orderID)}
                              color="teal"
                              size="small"
                              label={
                                loader
                                  ? 'wait..'
                                  : conveyanceFormId === ''
                                    ? 'submit'
                                    : 're-submit'
                              }
                            />
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            ) : null}
            {/* End of Conveyance form. */}
            {details.suiteOnBoardingFAQs &&
              details.suiteOnBoardingFAQs.length > 0 && (
                <FaqsList
                  suiteOnBoardingFAQs={details.suiteOnBoardingFAQs}
                  selectedFaqsId={selectedFaqsId}
                  handleSelectFaqs={handleSelectFaqs}
                />
              )}
            {details &&
            details.suiteOnBoardingOffers &&
            details.suiteOnBoardingOffers.length > 0 ? (
              <div className="mainRow mt-20">
                <div className="checklist">
                  <h2>Offers</h2>
                  <div className="offersSection">
                    {details &&
                    details.suiteOnBoardingOffers &&
                    details.suiteOnBoardingOffers.length > 0 ? (
                      <Carousel autoPlay={false} showThumbs={false}>
                        {details.suiteOnBoardingOffers.map((offer: any) => {
                          return (
                            <div className="offersDiv">
                              <div className="leftImg">
                                <img src={offer.logo} alt="" />
                              </div>
                              <div className="offersContent">
                                <p style={{ color: '#000', fontWeight: '600' }}>
                                  {offer.name}
                                </p>
                                <TextEditor
                                  editorState={offer.description}
                                  readOnly={true}
                                />
                                <a
                                  href={offer.linkName}
                                  target="_blank"
                                  style={{ color: '#000', float: 'left' }}
                                >
                                  {offer.linkName}
                                </a>
                              </div>
                            </div>
                          );
                        })}
                      </Carousel>
                    ) : (
                      <div style={{ padding: '10px', textAlign: 'center' }}>
                        No offers found.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </>
        ) : null}
        {state.isOpenPopup ? (
          <AddNote data={state} onAddNote={onAddNote} onSetNote={onSetNote} />
        ) : null}
        {state.isOpenDocumentPopup ? (
          <AddDocument
            data={state}
            onAddDocument={(type: any) => onAddDocument(type)}
            onSelectDocuments={onSelectDocuments}
            onDeleteDoc={onDeleteDoc}
            imageLoading={state.imageLoading}
          />
        ) : null}
      </div>
    </DocumentTitle>
  );
};

export default HomeOwnerOnboardingDashboard;
